import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ModuleService from "../../controller/ModuleController/ModuleController";
import UserDefineService from "../../controller/UserDefineController/UserDefineController";
import CreateUserDefineField from "./CreateUserDefineFields";
import HelpSite from "../../../Common/HelpLink";
import Swal from 'sweetalert2';
function CompanySetup() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [moduleList, setModuleList] = useState([]);
    const [KeyNameList, setKeyNames] = useState([]);
    const [KeyTypeList, setKeyType] = useState([]);
    const [formData, setFormData] = useState({ ModuleID: "0" });
    const { theme } = useContext(ThemeContext);
    const [currentUser, setCurrentUser] = useState(null);
    const [modalInstance, setModalInstance] = useState(null);

    const fetchModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            let ModuleList = await ModuleService.GetAllModules(redirectCallback, "en");
            ModuleList = ModuleList.filter(x => x.PK_SearchModule_ID != "11" && x.PK_SearchModule_ID != "12");
            setModuleList(ModuleList || []);
        } catch (error) {
            console.error('Error fetching Modules:', error);
        }
    };

    const fetchKeyType = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const keyTypes = await UserDefineService.GetAllKeyTypes(redirectCallback);
            setKeyType(keyTypes || []);
        } catch (error) {
            console.error('Error fetching Key Types:', error);
        }
    };

    const fetchKeyNames = async (moduleId) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await UserDefineService.GetAllUserDefineFields(moduleId, redirectCallback);
            setKeyNames(KeyNames || []);
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    useEffect(() => {
        fetchModules();
        fetchKeyNames(0);
    }, []);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('UserDefineModal')));
    }, []);

    const handleChange = async (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        if (name === 'ModuleID') {
            await fetchKeyNames(value);
        }
    };

    const handleCreateUserClick = async () => {
        if (formData.ModuleID > 0) {
            setCurrentUser(null);
            await fetchKeyType();

            if (modalInstance) {
                modalInstance.show();
            }
        }
        else {
            Swal.fire({
                title: '',
                text: `Please select module to create user define field.`,
                icon: 'warning'
            });
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const handleEditClick = async (user) => {
        debugger;
        await fetchKeyType();
        setCurrentUser(user);
        if (modalInstance) {
            modalInstance.show();
        }

    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await UserDefineService.DeleteUserDefineFields(ID);
                    fetchKeyNames(formData.ModuleID); // Refresh the list after deletion
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <label htmlFor="ModuleID" className="col-sm-2 col-form-label">Select Module</label>
                <div className="col-sm-4">
                    <select name="ModuleID" className="form-control" onChange={handleChange} value={formData.ModuleID}>
                        <option value="0">Select Module</option>
                        {moduleList.map((module) => (
                            <option key={module.PK_SearchModule_ID} value={module.PK_SearchModule_ID}>
                                {module.vc_ModuleName}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-sm-6" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="User Defined Fields" Module="26" />
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <table className="table m-0 table-hover">
                    <thead>
                        <tr>
                            <th>Field Name</th>
                            <th>Description</th>
                            <th>Module</th>
                            <th>Type</th>
                            <th style={{ "textAlign": "right" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {KeyNameList.map((keyName) => (
                            <tr key={keyName.PK_KeyName_ID} onClick={() => handleEditClick(keyName)}>
                                <td>{keyName.vc_Name}</td>
                                <td>{keyName.vc_Description}</td>
                                <td>{keyName.vc_ModuleName}</td>
                                <td>{keyName.TypeName}</td>
                                <td style={{ "textAlign": "right" }}>

                                    <button className="text-danger" style={{ "background": "none", "border": "none" }}
                                        onClick={(event) => handleDeleteClick(event, keyName.PK_KeyName_ID)}>

                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                    <button type="button" className="btn btn-primary" onClick={handleCreateUserClick}> <i className="icofont-plus" aria-hidden="true"> Add New</i></button>
                </div>

                <CreateUserDefineField
                    keyName={currentUser}
                    onClose={handleCloseModal}
                    onSuccess={() => fetchKeyNames("0")}
                    keyTypes={KeyTypeList}
                    moduleList={moduleList}
                    selectedModule={formData.ModuleID}
                />
            </div>
        </div>
    );
}

export default CompanySetup;
